import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import SoftwareUpdate from '../views/SoftwareUpdate.vue';
const Manual = () => import('../views/ManualMachine.vue');
const MissionMonitoring = () => import('../views/MissionMonitoring.vue');
const Authentication = () => import('../views/Auth.vue');
const Users = () => import('../views/Users.vue');
const Fields = () => import('../views/Fields.vue');
const Paths = () => import('../views/Paths.vue');
const InProgressMissions = () => import('../views/MissionEditing/InProgressMissions.vue');
const CompletedMissions = () => import('../views/MissionEditing/CompletedMissions.vue');
const MissionReport = () => import('../views/MissionEditing/MissionReport.vue');
const About = () => import('../views/About.vue');
const Alarm = () => import('../views/Alarm.vue');
const UploadPath = () => import('../views/UploadPath.vue');
const AddAndEditMissions = () => import('../views/MissionEditing/AddAndEditMissions.vue');
const AddNewMission = () => import('../views/MissionEditing/AddNewMission.vue');
import UserGuide from '../views/UserGuide.vue';
import { Auth } from '@aws-amplify/auth';
import i18n from '@/i18n';
Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, title: '' }
  },
  {
    path: '/manual',
    name: 'Manual',
    component: Manual,
    meta: { requiresAuth: true, title: '' }
  },
  {
    path: '/monitor',
    name: 'MissionMonitoring',
    component: MissionMonitoring,
    meta: { requiresAuth: true, title: '' }
  },
  {
    path: '/update',
    name: 'SoftwareUpdate',
    component: SoftwareUpdate,
    props: true,
    meta: { requiresAuth: true, title: '' }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: Authentication,
    meta: { requiresAuth: false, title: '' }
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: { requiresAuth: true, title: i18n.t('router.users_list') }
  },
  {
    path: '/fields',
    name: 'Fields',
    component: Fields,
    meta: { requiresAuth: true, title: i18n.t('router.fields') }
  },
  {
    path: '/paths',
    name: 'Paths',
    component: Paths,
    meta: { requiresAuth: true, title: i18n.t('router.fields') }
  },
  {
    path: '/uploadPath',
    name: 'UploadPath',
    component: UploadPath,
    meta: { requiresAuth: true, title: i18n.t('paths') }
  },
  {
    path: '/inprogressmissions',
    name: 'InProgressMissions',
    component: InProgressMissions,
    meta: { requiresAuth: true, title: i18n.t('router.missions') }
  },
  {
    path: '/completedmissions',
    name: 'CompletedMissions',
    component: CompletedMissions,
    meta: { requiresAuth: true, title: i18n.t('router.missions') }
  },
  {
    path: '/editmissions',
    name: 'AddAndEditMissions',
    component: AddAndEditMissions,
    meta: { requiresAuth: true, title: i18n.t('router.missions') }
  },
  {
    path: '/missionreport/:deploymentId?',
    name: 'MissionReport',
    component: MissionReport,
    meta: { requiresAuth: true, title: i18n.t('router.missions') }
  },
  {
    path: '/newmission',
    name: 'AddNewMission',
    component: AddNewMission,
    meta: { requiresAuth: true, title: i18n.t('router.adding_mission') }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { requiresAuth: false, title: '' }
  },
  {
    path: '/alarm/:machineId?',
    name: 'Alarm',
    component: Alarm,
    meta: { requiresAuth: true }
  },
  {
    path: '/userguide',
    name: 'UserGuide',
    component: UserGuide,
    meta: { requiresAuth: false, title: '' }
  },
  {
    path: '*',
    redirect: '/home'
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve((to, from, next) => {
  if (to.name === from.name) {
    return;
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    Auth.currentAuthenticatedUser()
      .then(() => {
        next();
      })
      .catch(async () => {
        try {
          await Auth.signOut();
        } catch (error) {
          console.error('error signing out: ', error);
        }
        next({
          path: '/auth'
        });
      });
  } else if (to.name == 'Auth') {
    Auth.currentSession()
      .then((session) => {
        if (session.isValid()) {
          next({
            path: '/home'
          });
        } else {
          next();
        }
      })
      .catch(() => {
        next();
      });
  } else {
    next();
  }
});

export default router;
